import { createContext } from "react";

import type { User } from "@entities/user";
import type { Company } from "@entities/company";
import { type RoleAbility } from "../access-control/index";
import { defineStaffMemberAbilities } from "../access-control/abilities";

interface AuthenticationContext {
  abilities: RoleAbility;
  activeCompany: Company | void;
  accountTitle: string;
  user?: User | null;
  loggedIn: boolean;
  firstName: string;
  lastName: string;
  email: string;
  logOut: (redirectTo?: string) => void;
  setUser: (user: User) => void;
  setActiveCompany: (company: Company | void) => void;
  revalidateSession: () => void;
  isCurrentCompanyManager: boolean;
  isSuperuserActingBehalfOfCompany: boolean;
  /** A superuser with no active company — the only state with superuser authority. */
  isSuperuserInAdminMode: boolean;
  isManagerInInternalCompany: (companyId: number) => boolean;
}

const initialContext: AuthenticationContext = {
  user: null,
  loggedIn: false,
  firstName: "",
  lastName: "",
  email: "",
  logOut: () => {},
  setUser: () => {},
  accountTitle: "",
  activeCompany: void 0,
  setActiveCompany: () => {},
  revalidateSession: () => {},
  isCurrentCompanyManager: false,
  abilities: defineStaffMemberAbilities(),
  isSuperuserActingBehalfOfCompany: false,
  isSuperuserInAdminMode: false,
  isManagerInInternalCompany: () => false,
};

export const AuthenticationContext =
  createContext<AuthenticationContext>(initialContext);
